<template>
    <v-form
        v-model="inputs_valid"
        action="/login"
        method="post"
        ref="login_form"
        class="px-0 mx-0 tw-h-screen md:tw-h-auto"
        v-on:submit.prevent
    >

        <v-container>
            <div class="tw-flex tw-justify-center">
                <v-text-field v-show="false" type="hidden" id="_token" name="_token" v-model="token"/>
                <v-text-field v-show="false" type="hidden" id="device" name="device" v-model="device"/>

                <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-justify-end tw-px-0 md:tw-px-14 tw-pt-12 md:tw-pt-6 tw-pb-2">
                    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-3">
                        <v-text-field
                            v-model="email"
                            :rules="email_rules"
                            label="Email"
                            id="email"
                            type="email"
                            name="email"
                            hide-details="auto"
                            :error-messages="errors?.email"
                            required
                            autofocus
                        ></v-text-field>
                        <v-text-field
                            v-model="password"
                            :rules="[password_rules.required]"
                            :type="show_password ? 'text' : 'password'"
                            label="Password"
                            id="password"
                            name="password"
                            hide-details="auto"
                            :error-messages="errors?.password"
                            required
                            autocomplete="current-password"
                            :append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="show_password = !show_password"
                        ></v-text-field>
                    </div>
                    <div class="tw-flex tw-flex-row tw-gap-3 tw-py-2 tw-justify-center md:tw-justify-end tw-content-center tw-text-sm">
                        <div class="tw-flex tw-mt-1.5" :class="{ 'tw-text-gray-800': inputs_valid, 'tw-text-gray-300': !inputs_valid }">
                           How do you want to receive the code
                        </div>
                        <v-radio-group row v-model="code_method" mandatory :disabled="!inputs_valid">
                            <v-radio
                                value="text"
                                hide-details="auto"
                            >
                                <template v-slot:label>
                                    <div class="tw-text-sm" :class="{ 'tw-text-gray-800': inputs_valid, 'tw-text-gray-300': !inputs_valid }">Text Message</div>
                                </template>
                            </v-radio>
                            <v-radio
                                value="voice"
                                hide-details="auto"
                                style="margin-right:10px !important;"
                            >
                                <template v-slot:label>
                                    <div class="tw-text-sm" :class="{ 'tw-text-gray-800': inputs_valid, 'tw-text-gray-300': !inputs_valid }">Phone Call</div>
                                </template>
                            </v-radio>
                            <v-radio
                                value="email"
                                hide-details="auto"
                                style="margin-right:0px !important;"
                            >
                                <template v-slot:label>
                                    <div class="tw-text-sm" :class="{ 'tw-text-gray-800': inputs_valid, 'tw-text-gray-300': !inputs_valid }">Email</div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </div>
                    <div class="tw-flex tw-flex-col-reverse md:tw-flex-row tw-justify-start md:tw-justify-end tw-items-start md:tw-items-center tw-gap-4">
                        <a @click="$emit('view', 'AuthBarForgotPw')" class="text-link tw-text-xs tw-underline tw-mr-0 md:tw-mr-20">
                            I've forgotten my password
                        </a>
                        <v-btn
                            type="submit"
                            @click="attemptLogin"
                            :disabled="!inputs_valid"
                            class="main-btn tw-w-full md:tw-w-48"
                        >
                            Continue
                        </v-btn>
                    </div>
                </div>

            </div>
        </v-container>


    </v-form>
</template>

<script>

import {DeviceUUID} from 'device-uuid';

export default {
    name: "AuthBarLogin",

    data: () => ({
        inputs_valid: false,
        email: '',
        email_rules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        password: '',
        password_rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
        },
        show_password: false,
        token: null,
        device: null,
        expanded_panel_index: null,
        errors: null,
        code_method: null,
    }),

    computed: {
        payload: function () {
            return {
                email: this.email,
                password: this.password,
                device: this.device,
                code_method: this.code_method,
            }
        },
    },

    methods: {
        reset () {
            this.expanded_panel_index = null
            this.$nextTick(()=>{
                this.$refs.login_form.reset()
            })
        },
        resetValidation () {
            this.$refs.login_form.resetValidation()
            this.errors = null
        },
        getDeviceId () {
            return new DeviceUUID().get()
        },
        getToken () {
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        async attemptLogin () {
            axios.post('/login', this.payload)
                .then((response) => {
                    if (response?.data?.two_factor) {

                        this.$emit('view', 'AuthBar2faCode')
                        // if (response?.data?.code) {
                        //     this.$root.snackbar.success(`Your code: ${response?.data?.code}`)
                        // }
                    } else if (response?.data?.two_factor_needs_setup) {
                        // The user should be redirected instead of finding their way here
                    }
                    else {
                        window.location = '/'
                    }

                })
                .catch((error) => {
                    if( error?.response ) {
                        this.$root.snackbar.error(error.response.data.message)
                        this.errors = error.response?.data?.errors
                    } else {
                        console.log(error)
                        this.$root.snackbar.error(error)
                    }
                })
        },
    },

    created() {
        this.attemptLogin = _.debounce(this.attemptLogin, 666) // Replace this function with a debounced version of itself
    },

    mounted() {
        this.token = this.getToken()
        this.device = this.getDeviceId()
    },
    watch: {
        email(newValue, oldValue) {
            this.resetValidation()
        },
        password(newValue, oldValue) {
            this.resetValidation()
        },
    }
}
</script>
<style scoped>
.v-input--selection-controls {
    margin-top: 0px !important;
}
.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    font-size: 12px !important;
}
</style>
